import React from 'react';

const ErrorTest: React.FC = () => {
  throw new Error('Test Error');
};

export default ErrorTest;
